import DesktopA from './layouts/desktop/A'
import MobileA from './layouts/mobile/A'

export const MobileFactory = {
  A: <MobileA />,
}

export const DesktopFactory = {
  A: <DesktopA />,
}
